<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>

    <v-footer class="pa-0 pr-2" height="30" style="min-height: 25px !important" app>
      <v-spacer></v-spacer>
      <div style="color: #aaa">
        <small>
          &copy; {{ new Date().getFullYear() }} Simona Tunno SRLS - Certificazioni e Consulenza aziendale - P.IVA 04203910049
          <a :href="urlPrivacy" target="_blank">Privacy policy</a>
        </small>
      </div>
    </v-footer>

    <!-- Plugin -->
    <toast></toast>
    <confirm></confirm>
    <wait></wait>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    urlPrivacy: "https://www.simonatunno.it/index.php?option=com_content&view=article&id=6&Itemid=121",
  }),
  name: "App",
};
</script>
